import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import PointManager from "../PointManager/PointManager";
import LineManager from "../LineManager";
import { runCircleAnimation } from "./CircleAnimationSquence";
import Circle from "../../../../../../src/entities/Circle";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { Coord } from "../../../../../../src/types/Interface";
import { ContextType } from "../../types/Interface";
import { INFO_SLIDER_COORD } from "../../types/Config";


export default class CircleAnimationManager {
	constructor(
		private PointManager: PointManager,
		private LineManager: LineManager,
		private circle: Circle,
		private cCoord: Coord,
	) {
		this.addCircAnimBut();
	}
	addCircAnimBut = () => new CircleAnimationButton(INFO_SLIDER_COORD, () => this.runAnimations());

	runAnimations() {
		rootEventBus.emit(EnumRootEventBus.startedCircleAnim);

		const context: ContextType = {
			PointManager: this.PointManager,
			LineManager: this.LineManager,
			circle: this.circle,
			cCoord: this.cCoord
		}

		runCircleAnimation(context, () => {
			rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
			rootEventBus.emit(EnumRootEventBus.completedCircleAnim);
		});
	}
}
